import { ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";

/**
 * Facturación / Cajas selector.
 *
 * Props:
 * - units:    the selectable units (from `feature.units()`): { value, label, Icon }.
 * - value:    the currently selected unit, or null when charts disagree (the global toggle
 *             renders no selection while units are mixed).
 * - onChange: called with the chosen unit.
 * - compact:  icon-only buttons with tooltips, for the tight chart-tile headers. The default
 *             renders the icon next to its label, for the toolbar-level toggle.
 */
function UnitToggle({ units, value, onChange, compact = false }) {
    const handleChange = (_event, nextUnit) => {
        if (nextUnit != null) {
            onChange(nextUnit);
        }
    };

    return (
        <ToggleButtonGroup value={value} exclusive size="small" onChange={handleChange}>
            {units.map(({ value: unitValue, label, Icon }) => (
                <Tooltip key={unitValue} title={compact ? label : ""} disableHoverListener={!compact}>
                    <ToggleButton value={unitValue} sx={{ textTransform: "none", gap: 0.5, px: compact ? 0.75 : 1.25 }}>
                        <Icon fontSize="small" />
                        {!compact && label}
                    </ToggleButton>
                </Tooltip>
            ))}
        </ToggleButtonGroup>
    );
}

export default UnitToggle;
